import { useMemo, useState } from "react"

type SortByValue = "a-z" | "z-a"

export const useSortBy = (key: string) => {
  const [value, setValue] = useState<SortByValue>("a-z")

  const sortValue = useMemo(() => {
    if (value === "a-z") return key
    if (value === "z-a") return `-${key}`

    return key
  }, [value])

  return {
    value,
    setValue,
    sortValue,
  }
}
